export { default as CalendarIcon } from 'vectors/Calendar';
export { default as CartIcon } from 'vectors/Cart';
export { default as ChartNoAxesCombinedIcon } from 'vectors/ChartNoAxesCombined';
export { default as CloseIcon } from 'vectors/Close';
export { default as CollapseIcon } from 'vectors/Collapse';
export { default as ConfigureIcon } from 'vectors/Configure';
export { default as CreateIcon } from 'vectors/Create';
export { default as DashboardIcon } from 'vectors/Dashboard';
export { default as DownloadIcon } from 'vectors/Download';
export { default as DuplicateIcon } from 'vectors/Duplicate';
export { default as EditDocumentIcon } from 'vectors/EditDocument';
export { default as ExploreIcon } from 'vectors/Explore';
export { default as FeedbackIcon } from 'vectors/Feedback';
export { default as FilterIcon } from 'vectors/Filter';
export { default as GlobeIcon } from 'vectors/Globe';
export { default as GlobeStandIcon } from 'vectors/GlobeStand';
export { default as HelpIcon } from 'vectors/Help';
export { default as InfoIcon } from 'vectors/Info';
export { default as LayersIcon } from 'vectors/Layers';
export { default as PageIcon } from 'vectors/PageIcon';
export { default as PlusIcon } from 'vectors/Plus';
export { default as PortfoliosIcon } from 'vectors/Portfolios';
export { default as ProcurementIcon } from 'vectors/Procurement';
export { default as ReferAndEarnIcon } from 'vectors/ReferAndEarn';
export { default as RestartOnboardingIcon } from 'vectors/RestartOnboarding';
export { default as SearchIcon } from 'vectors/Search';
export { default as SendHorizontalIcon } from 'vectors/SendHorizontal';
export { default as SettingsIcon } from 'vectors/Settings';
export { default as ShareIcon } from 'vectors/Share';
export { default as SidebarIcon } from 'vectors/Sidebar';
export { default as TrashIcon } from 'vectors/Trash';
export { default as UploadIcon } from 'vectors/Upload';
export { default as VendorIcon } from 'vectors/Vendor';
export { default as WalletIcon } from 'vectors/Wallet';
